import ProfileModel from './profile-model';
import tomProfile from './profile-pictures/tom.jpeg';

const tom = new ProfileModel({
    username: 'tom',
    password: 'admin',
    profilePicture: tomProfile,
    firstName: 'Tommy',
    lastName: 'Smale',
    files: [
        "//v2.grommet.io/assets/Wilderpeople_Ricky.jpg"
    ],
    key: 4,
})

export default tom;